import React, { useState, useEffect, useRef, } from 'react';
import { Col, Dropdown, Overlay, Tooltip, Button, } from 'react-bootstrap';
import { apiUrl_api, } from './url.jsx';

function ColDropdownSpeech({ isMobile, onSelect, onClick, isRecording=false }) {
    const [selectedOption, setSelectedOption] = useState("");
    const [showTooltip, setShowTooltip] = useState(false);
    const dropSpeechRef = useRef(null);
    const [optionsLanguage, setOptionsLanguage] = useState([]);

    const formatOptions = (data) => {
        const formattedOptions = data.map(item => ({
            label: item.OptionLabel,
            value: item.OptionValue,
            language: item.Alias
        }));
        
        setOptionsLanguage(formattedOptions);
    };
    
    useEffect(() => {
        // 获取数据库中语言选项
        const bodyData = {option_class: "language"}
        fetch(apiUrl_api + "/options", {        
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(bodyData),
            keepalive: true,
        })
        .then(response => response.json())
        .then(data => {
            const dataArray = JSON.parse(data);
            formatOptions(dataArray); // 调用formatOptions函数来格式化选项
        })
        .catch(error => {
            console.error(error);
        });
    }, []);

    useEffect(() => {  
        // 根据计算机的语言设置选择选项（可选）
        if(optionsLanguage.length > 0) {
            const userLang = navigator.language || navigator.userLanguage;       
            if (userLang === 'ja-JP') {
                setSelectedOption(optionsLanguage[2].label);
            } else if (userLang === 'en-US') {
                setSelectedOption(optionsLanguage[1].label);
            } else {
                setSelectedOption(optionsLanguage[0].label);
            }
        }
    }, [optionsLanguage])

    return (
        <Col className="align-items-center" style={{ display: "flex" }}>
            <Dropdown>
                <Dropdown.Toggle
                    // variant= {isRecording ? "outline-warning": "outline-success"}
                    variant="outline-success"
                    id="dropdown-speech"
                    className="me-2"
                    ref={dropSpeechRef}
                    onMouseEnter={() => setShowTooltip(true)}
                    onMouseLeave={() => setShowTooltip(false)}
                >
                    <i className="bi bi-translate"></i> {selectedOption}
                </Dropdown.Toggle>

                <Overlay target={dropSpeechRef.current} show={showTooltip} placement="top">
                    {(props) => (
                        <Tooltip id="overlay-translate" {...props}>
                            选择录音的语言
                        </Tooltip>
                    )}
                </Overlay>

                <Dropdown.Menu>
                {optionsLanguage.map((option) => (
                    <Dropdown.Item
                        key={option.value}
                        onClick={() => {
                            setSelectedOption(option.label)
                            onSelect(option.language, option.value); // 调用父组件传递的 onSelect 函数
                        }}
                    >
                        {option.label}
                    </Dropdown.Item>
                ))}
                </Dropdown.Menu>
            </Dropdown>

            <Button
                // variant= {isRecording ? "outline-warning": "outline-success"}
                variant="outline-success"
                className="me-2" // 添加右边距
                // style={{ display: "inline-block", width: "auto" }}
                style={{ display: isMobile ? "none" : "inline-block", width: "auto" }}
                onClick={onClick}
            >                    
                <i className="bi bi-download"></i> 对话
            </Button>
        </Col> 
    );
}

export default ColDropdownSpeech;